import React from 'react';
import { Text, TextTypography } from 'wix-ui-tpa/cssVars';
import { classes } from './TitleSection.st.css';
import { useTitleSettings } from './useTitleSettings';
import { FormType } from '../../../types/types';
import { useStyles } from '@wix/tpa-settings/react';
import loginStylesParams from '../../Login/stylesParams';
import signupStylesParams from '../../Signup/stylesParams';
import { TEXT_DIRECTION } from '../../../constants';
import { useEnvironment } from '@wix/yoshi-flow-editor';

interface TitleSectionProps {
  formType: FormType;
  ssoMandatory: boolean;
}

export const TitleSection = ({ formType, ssoMandatory }: TitleSectionProps) => {
  const { isTitleVisible, isSubtitleVisible, titleText, subtitleText } =
    useTitleSettings({ formType, ssoMandatory });
  const { isRTL } = useEnvironment();

  const styles = useStyles();

  const stylesParams =
    formType === 'login' ? loginStylesParams : signupStylesParams;

  const titleFont = styles.get(stylesParams.titleFont);

  return (
    <div
      className={classes.titleSection}
      dir={isRTL ? TEXT_DIRECTION.RTL : TEXT_DIRECTION.LTR}
    >
      {isTitleVisible && (
        <Text
          data-hook={`${formType}-title`}
          typography={TextTypography.largeTitle}
          className={classes.title}
          tagName={titleFont?.htmlTag || 'h2'}
        >
          {titleText}
        </Text>
      )}
      {isSubtitleVisible && (
        <Text data-hook={`${formType}-subtitle`} className={classes.subtitle}>
          {subtitleText}
        </Text>
      )}
    </div>
  );
};
